import * as React from 'react';
import MuiDivider, { DividerProps as MuiDividerProps } from '@material-ui/core/Divider';

import styled from 'styled-components';

const StyledDivider = styled(MuiDivider)``;

export type DSDividerProps = Omit<MuiDividerProps, 'component'>;
export const DSDivider: React.FC<DSDividerProps> = props => <StyledDivider {...props} />;
DSDivider.displayName = 'DSDivider';
